import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarRange, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export function RecapCard() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/recap/weekly").then((res) => setR(res.data)).catch(() => {}); }, []);
  if (!r || !r.lessons || localStorage.getItem("btp_recap_seen") === r.week_start) return null;
  return (
    <Link
      to="/bilan"
      data-testid="home-recap-card"
      className="rise flex items-center gap-4 rounded-2xl bg-amber-100 border-2 border-amber-300 hover:border-amber-500 p-4 text-amber-900 transition-colors"
    >
      <span className="w-12 h-12 rounded-xl bg-amber-400 text-slate-900 grid place-items-center">
        <CalendarRange className="w-6 h-6" />
      </span>
      <span className="flex-1">
        <span className="block font-display text-2xl font-bold leading-none">Bilan de la semaine</span>
        <span className="block text-sm">{r.lessons} leçon(s) · {r.words_count} mot(s){r.trophy ? " · 1 trophée" : ""}</span>
      </span>
      <ArrowRight className="w-6 h-6" />
    </Link>
  );
}
